import React, { useState } from 'react';
import {
    Toast,
    LoadingIndicator,
    ProjectFeatureToggleFlags,
    ProjectUnitVariables,
    ResidentialUnitCustomFieldTypeDto,
    useProjectHasFeatureToggle,
} from '@ygtechnologies/bygr-frontend-component-library';
import { useAsyncState, useGetActiveProfile } from '@/utils/hooks';
import { getUnitVariableTypes, saveUnitVariableTypes } from '@/services/project-unit-variables';
import { Trans } from '@lingui/react/macro';

export interface ProjectSettingsUnitVariablesProps {
    projectId: number;
}

export const ProjectSettingsUnitVariables: React.FC<ProjectSettingsUnitVariablesProps> = ({ projectId }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [unitVariables, setUnitVariables] = useAsyncState<ResidentialUnitCustomFieldTypeDto[] | null>(
        () => getUnitVariableTypes(projectId),
        [],
        null
    );
    const onSave = async (unitVariables: ResidentialUnitCustomFieldTypeDto[]) => {
        try {
            setIsSaving(true);
            const newUnitVariable = await saveUnitVariableTypes(projectId, unitVariables);
            setUnitVariables(newUnitVariable);
            Toast.success(<Trans>Saved unit variable</Trans>);
        } finally {
            setIsSaving(false);
        }
    };

    const useApi = useProjectHasFeatureToggle(ProjectFeatureToggleFlags.ValidateProjectUnitVariables);

    return (
        <>
            {!unitVariables ? (
                <LoadingIndicator />
            ) : (
                <ProjectUnitVariables
                    unitVariables={unitVariables}
                    onUnitVariablesChange={onSave}
                    isSaving={isSaving}
                    useApi={useApi}
                />
            )}
        </>
    );
};
